"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _ProductDetailContext = _interopRequireDefault(require("../../../ProductDetail/context/ProductDetailContext"));
var _Message = _interopRequireDefault(require("./Message"));
var _Price = _interopRequireDefault(require("./Price"));
var _PriceSlider = _interopRequireDefault(require("./PriceSlider"));
var _Salutation = _interopRequireDefault(require("./Salutation"));
var _VoucherSelection = _interopRequireDefault(require("./VoucherSelection.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const VoucherSelection = _ref => {
  let {
    lang
  } = _ref;
  const {
    productDetailData
  } = (0, _react.useContext)(_ProductDetailContext.default);
  const {
    id: productID,
    price = {}
  } = productDetailData || {};
  const css = (0, _VoucherSelection.default)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.voucherSelection, "mco-shop-product-detail-voucher-selection")
  }, /*#__PURE__*/_react.default.createElement("form", null, productID && /*#__PURE__*/_react.default.createElement("input", {
    name: "productID",
    type: "hidden",
    value: productID
  }), !(0, _isEmpty.default)(price) ? /*#__PURE__*/_react.default.createElement(_Price.default, {
    lang: lang
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Salutation.default, {
    lang: lang
  }), /*#__PURE__*/_react.default.createElement(_Message.default, {
    lang: lang
  }), /*#__PURE__*/_react.default.createElement(_PriceSlider.default, null))));
};
var _default = exports.default = VoucherSelection;